
type TOSCheckboxProps = {
  checked: boolean;
  onChange: () => void;
  tosLink: string;
}

const TOSCheckbox: React.FC<TOSCheckboxProps> = ({
  checked,
  onChange,
  tosLink,
}) => {

  return (
    <div
      className={`checkbox ${checked ? 'checkbox-checked' : ''}`}
    >
      <label className="text-center w-full flex pb-4">
        <input
          type="checkbox"
          data-testid="signupForm_tosCheckbox"
          data-cy="signupForm_tosCheckbox"
          checked={checked}
          onChange={() => onChange()}
          className="mr-2"
        />
        <span className="text-left pl-2">
          I agree to the Peazy{' '}
          <a
            href={tosLink}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-primary"
          >
            Terms of Service
          </a>
          {' '}and{' '}
          <a
            href="https://bookpeazy.com/peazy-privacypolicy"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-primary"
          >
            Privacy Policy
          </a>
          .
        </span>
      </label>
    </div>
  );
};

export default TOSCheckbox;
